module.exports = __webpack_public_path__ + "static/media/Pham_Quang_Ha.d28e33c0.jpg";